const ITEMS = [
  "Aus Liebe entstanden. Für dich gemacht.",
  "Fachfußpflege",
  "Weil jeder Schritt zählt.",
  "Fußreflexzonenmassage",
  "Maison Princess · Bensheim",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-3xl italic text-ink sm:px-12 sm:text-5xl lg:text-6xl">{t}</span>
        <span className="text-xl text-gold">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee" className="overflow-hidden border-y border-gold/25 bg-champagne py-7 sm:py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
